import { addListener, createListenerMiddleware } from '@reduxjs/toolkit'
import { AppDispatch, ReduxState } from './store'

export const listenerMiddleware = createListenerMiddleware()

export const addAppListener = addListener.withTypes<ReduxState, AppDispatch>()
